import { createAction, props } from '@ngrx/store';

import type { UserDetailsFragment } from 'generated/graphql';

export const setCurrentUser = createAction(
  '[Auth] Set Current User',
  props<{ payload: Partial<UserDetailsFragment> }>()
);

export const clearCurrentUser = createAction(
  '[Auth] Clear Current User'
);

export const setPasswordResetMessage = createAction(
  '[Auth] Set Password Reset Message', props<{ message: string }>()
);

export const clearPasswordResetMessage = createAction(
  '[Auth] Clear Password Reset Message'
);
